import { useCallback } from 'react'

import { useLocation, useNavigate } from '@/routing'
import { getContextSwitchTargetPath } from '@/utils/contextSwitchNavigation'

export const useContextSwitchDispatcher = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const dispatchContextSwitchNavigation = useCallback(
    (targetContextIri: string | null) => {
      const targetPath = getContextSwitchTargetPath({
        currentPathname: location.pathname,
        targetContextIri,
      })
      const nextUrl = `${targetPath}${location.search}`
      const currentUrl = `${location.pathname}${location.search}`

      if (nextUrl === currentUrl) {
        return
      }

      navigate(nextUrl, { replace: true })
    },
    [location.pathname, location.search, navigate]
  )

  return { dispatchContextSwitchNavigation }
}
